export default (msg: string | { message: string }) => {
  const message = typeof msg === 'string' ? msg : msg.message;

  const match = message.split(': ');

  if (match) {
    return { code: match[0], message: match[1] };
  }

  return {};
};
